import Swiper, {Navigation} from 'swiper';
class CardSlider {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError("Invalid element");
    }

    this.element = element;
    this.swiper = null;
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this.element, {
      allowTouchMove: true,
      modules: [Navigation],
      allowClick: true,
      slidesPerView: "auto",
      spaceBetween: 20,
      navigation: {
        prevEl: this.element.querySelector(".swiper-button.prev"),
        nextEl: this.element.querySelector(".swiper-button.next"),
      }
    });
  }
}

export default CardSlider;
